import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-procedure',
  templateUrl: './manage-procedure.component.html',
  styleUrls: ['./manage-procedure.component.scss']
})
export class ManageProcedureComponent implements OnInit {
  
  isChecked:boolean = true;
  showCaseDetail: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  openCaseDetail(){
    this.showCaseDetail = true;
  }
 
  getCloseCaseDetail(message){
    this.showCaseDetail = message;
  }

}
